export default __webpack_public_path__ + "static/icons-19be4b71b1fa6f369f480fd22670e873.svg";